/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React, { useState, useRef } from 'react';
import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Table from 'react-bootstrap/Table';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ListGroup from 'react-bootstrap/ListGroup';
import "./layout.css"
import {
  ThemeProvider
} from '@mui/material/styles';
import theme from "./theme";
import { Typography } from '@mui/material';
import Button from "@mui/material/Button";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import {isMobile} from "./mobile";

const linkStyles = {
  color: 'white',
  display: 'inline-block',
  margin: '0.28rem 0.5rem',
  padding: '0.25rem',
  textDecoration: 'none'
};

const activeStyles = {
  background: 'white',
  color: 'rebeccapurple'
};

export function NavigationBar() {
    const [isActivitiesOpen, setIsActivitiesOpen] = useState(false);
    const [isDharmaOpen, setIsDharmaOpen] = useState(false);
    const [isPracticeOpen, setIsPracticeOpen] = useState(false);
    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const [isLangOpen, setIsLangOpen] = useState(false);
  const [expandItem, setExpandItem]=React.useState(null);
  const [anchorEl, setAnchorEl]=useState(null);
  const open = Boolean(anchorEl);
  const handleExpandItem=(item)=>{
    if (expandItem==item) {
      setExpandItem(null);
    } else {
      setExpandItem(item);
    }
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let activitiesCloseTimer=null;
  const delayedCloseActivities=()=>{if (activitiesCloseTimer == null) {activitiesCloseTimer=setTimeout(() => {
  setIsActivitiesOpen(false);
}, 300)}};
  const openActivities=()=>{if (activitiesCloseTimer) {clearTimeout(activitiesCloseTimer); activitiesCloseTimer=null;} setIsActivitiesOpen(true);};

  let dharmaCloseTimer=null;
  const delayedCloseDharma=()=>{if (dharmaCloseTimer == null) {dharmaCloseTimer=setTimeout(() => {
  setIsDharmaOpen(false);
}, 300)}};
  const openDharma=()=>{if (dharmaCloseTimer) {clearTimeout(dharmaCloseTimer); dharmaCloseTimer=null;} setIsDharmaOpen(true);};

  let practiceCloseTimer=null;
  const delayedClosePractice=()=>{if (practiceCloseTimer == null) {practiceCloseTimer=setTimeout(() => {
  setIsPracticeOpen(false);
}, 300)}};
  const openPractice=()=>{if (practiceCloseTimer) {clearTimeout(practiceCloseTimer); practiceCloseTimer=null;} setIsPracticeOpen(true);};

  let aboutCloseTimer=null;
  const delayedCloseAbout=()=>{if (aboutCloseTimer == null) {aboutCloseTimer=setTimeout(() => {
  setIsAboutOpen(false);
}, 300)}};
  const openAbout=()=>{if (aboutCloseTimer) {clearTimeout(aboutCloseTimer); aboutCloseTimer=null;} setIsAboutOpen(true);};

  let langCloseTimer=null;
  const delayedCloseLang=()=>{if (langCloseTimer == null) {langCloseTimer=setTimeout(() => {
  setIsLangOpen(false);
}, 300)}};
  const openLang=()=>{if (langCloseTimer) {clearTimeout(langCloseTimer); langCloseTimer=null;} setIsLangOpen(true);};

  let navItems= <><Nav.Item><Button className="bg-blue-500 text-white rounded"style={{ background: "#282c34", color: "white", width: "2rem" }}>
<Link style={{
color: 'white',
display: 'inline-block',
textDecoration: 'none'
}} activeStyle={activeStyles} to="/"><Typography variant="h3" fontSize="1.1rem">主頁</Typography></Link></Button></Nav.Item>
<Nav.Item>
    <div
      onMouseEnter={() => openActivities()}
      onMouseLeave={() => delayedCloseActivities()}
      style={{ position: "relative", display: "inline-block" }}
    >
      <Button className="bg-blue-500 text-white rounded"style={{ background: "#282c34", color: "white", width: "2rem" }}><Typography variant="h3" fontSize="1.1rem">活動</Typography>
      </Button>
      {isActivitiesOpen &&
       <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "8px",
            minWidth: "200px",
            background: "#282c34",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
          onMouseEnter={() => openActivities()}
          onMouseLeave={() => delayedCloseActivities()}

        >
        <div onClick={() => setIsActivitiesOpen(false)}><Link to="/upcoming-events" style={linkStyles} activeStyle={activeStyles}><Typography variant="h3" fontSize="1.1rem">活動預告</Typography></Link></div>
      <div onClick={() => setIsActivitiesOpen(false)}><Link to="/activities" style={linkStyles} activeStyle={activeStyles}><Typography variant="h3" fontSize="1.1rem">道場活動安排</Typography></Link></div>
      <div onClick={() => setIsActivitiesOpen(false)}><Link to="/livestream" style={linkStyles} activeStyle={activeStyles}><Typography variant="h3" fontSize="1.1rem">直播</Typography></Link></div>
      <div onClick={() => setIsActivitiesOpen(false)}><Link to="/onlineClass" style={linkStyles} activeStyle={activeStyles}><Typography variant="h3" fontSize="1.1rem">線上共修</Typography></Link></div>
      <div onClick={() => setIsActivitiesOpen(false)}><Link to="/foqi" style={linkStyles} activeStyle={activeStyles}><Typography variant="h3" fontSize="1.1rem">佛七</Typography></Link></div>
      <div onClick={() => setIsActivitiesOpen(false)}><Link to="/chanqi" style={linkStyles} activeStyle={activeStyles}><Typography variant="h3" fontSize="1.1rem">禪七</Typography></Link></div>
      <div onClick={() => setIsActivitiesOpen(false)}><Link to="/relics" style={linkStyles} activeStyle={activeStyles}><Typography variant="h3" fontSize="1.1rem">舍利展</Typography></Link></div>
      </div>
      }
</div>
</Nav.Item>

<Nav.Item>

      <Button className="bg-blue-500 text-white rounded"style={{ background: "#282c34", color: "white", width: "2rem" }}>
<Link style={{
  color: 'white',
  display: 'inline-block',
  textDecoration: 'none'
}} activeStyle={activeStyles} to="/calendar"><Typography variant="h3" fontSize="1.1rem">日曆</Typography></Link></Button></Nav.Item>
<Nav.Item><div
      onMouseEnter={() => openDharma()}
      onMouseLeave={() => delayedCloseDharma()}
      style={{ position: "relative", display: "inline-block" }}
    >
      <Button className="bg-blue-500 text-white rounded"style={{ background: "#282c34", color: "white", width: "2rem" }}><Typography variant="h3" fontSize="1.1rem">佛法</Typography>
      </Button>
      {isDharmaOpen &&
       <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "8px",
            minWidth: "200px",
            background: "#282c34",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
      onMouseEnter={() => openDharma()}
      onMouseLeave={() => delayedCloseDharma()}

        >
        <div onClick={() => setIsDharmaOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/lecture"><Typography variant="h3" fontSize="1.1rem">講法音頻和幻燈片</Typography></Link></div>
      <div onClick={() => setIsDharmaOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/ceremonies"><Typography variant="h3" fontSize="1.1rem">法會錄音</Typography></Link></div>
      <div onClick={() => setIsDharmaOpen(false)}><Link style={linkStyles} activeStyle={activeStyles}  to="/blog"><Typography variant="h3" fontSize="1.1rem">法音博客</Typography></Link></div>
<div onClick={() => setIsDharmaOpen(false)}><Link style={linkStyles} activeStyle={activeStyles}  to="/qanda"><Typography variant="h3" fontSize="1.1rem">答疑</Typography></Link></div>
      </div>
      }
</div></Nav.Item>
<Nav.Item><div
      onMouseEnter={() => openPractice()}
      onMouseLeave={() => delayedClosePractice()}
      style={{ position: "relative", display: "inline-block" }}
    >
      <Button className="bg-blue-500 text-white rounded"style={{ background: "#282c34", color: "white", width: "2rem"  }} onClick={()=>setIsPracticeOpen(!isPracticeOpen)}><Typography variant="h3" fontSize="1.1rem">修行</Typography>
      </Button>
      {isPracticeOpen &&
       <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "8px",
            minWidth: "200px",
            background: "#282c34",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
      onMouseEnter={() => openPractice()}
      onMouseLeave={() => delayedClosePractice()}

        >
        <div onClick={() => setIsPracticeOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/practices"><Typography variant="h3" fontSize="1.1rem">修行</Typography></Link></div>
      <div onClick={() => setIsPracticeOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/training"><Typography variant="h3" fontSize="1.1rem">僧伽及居士訓練</Typography></Link></div>
      <div onClick={() => setIsPracticeOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/cultivation-stories"><Typography variant="h3" fontSize="1.1rem">禪修體驗</Typography></Link></div>
      </div>
      }
</div></Nav.Item>
<Nav.Item><Button className="bg-blue-500 text-white rounded"style={{ background: "#282c34", color: "white", width: "2rem" }}>
<Link style={{
  color: 'white',
  display: 'inline-block',
  textDecoration: 'none'
}} activeStyle={activeStyles} to="/publication"><Typography variant="h3" fontSize="1.1rem">書籍</Typography></Link></Button></Nav.Item>
<Nav.Item><div
      onMouseEnter={() => openAbout()}
      onMouseLeave={() => delayedCloseAbout()}
      style={{ position: "relative", display: "inline-block" }}
    >
      <Button className="bg-blue-500 text-white rounded"style={{ background: "#282c34", color: "white", width: "2rem"  }} onClick={()=>setIsPracticeOpen(!isPracticeOpen)}><Typography variant="h3" fontSize="1.1rem">簡介</Typography>
      </Button>
      {isAboutOpen &&
       <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "8px",
            minWidth: "200px",
            background: "#282c34",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
      onMouseEnter={() => openAbout()}
      onMouseLeave={() => delayedCloseAbout()}

        >
        <div onClick={() => setIsAboutOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/statement-of-faith"><Typography variant="h3" fontSize="1.1rem">我們的宗旨</Typography></Link></div>
      <div onClick={() => setIsAboutOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/location"><Typography variant="h3" fontSize="1.1rem">地址</Typography></Link></div>
      <div onClick={() => setIsAboutOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/master"><Typography variant="h3" fontSize="1.1rem">永化法師</Typography></Link></div>

      <div onClick={() => setIsAboutOpen(false)}><a href="mailto:xq2@chanpureland.org" style={linkStyles}>
<Typography variant="h3" fontSize="1.1rem">聯繫我們</Typography></a></div>
      <div onClick={() => setIsAboutOpen(false)}><Link style={linkStyles} activeStyle={activeStyles} to="/contribution"><Typography variant="h3" fontSize="1.1rem">護持捐款</Typography></Link></div>
      </div>
      }
</div></Nav.Item>

<Nav.Item><div
      onMouseEnter={() => openLang()}
      onMouseLeave={() => delayedCloseLang()}
      style={{ position: "relative", display: "inline-block" }}
    >
      <Button className="bg-blue-500 text-white rounded"style={{ background: "#282c34", color: "white", width: "2rem"  }} onClick={()=>setIsLangOpen(!isLangOpen)}><Typography variant="h3" fontSize="1.1rem">語言</Typography>
      </Button>
      {isLangOpen &&
       <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "8px",
            minWidth: "200px",
            background: "#282c34",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
      onMouseEnter={() => openLang()}
      onMouseLeave={() => delayedCloseLang()}

        >
        <div onClick={() => setIsLangOpen(false)}><a style={linkStyles} href="https://www.chanpureland.org/"><Typography variant="h3" fontSize="1.1rem">English</Typography></a></div>
      <div onClick={() => setIsLangOpen(false)}><a style={linkStyles} href="https://vn.chanpureland.org/"><Typography variant="h3" fontSize="1.1rem">Tiếng Việt</Typography></a></div>
      <div onClick={() => setIsLangOpen(false)}><a style={linkStyles} href="https://kr.chanpureland.org/"><Typography variant="h3" fontSize="1.1rem">한국어</Typography></a></div>

      <div onClick={() => setIsLangOpen(false)}><a style={linkStyles} href="https://es.chanpureland.org/">
<Typography variant="h3" fontSize="1.1rem">Español</Typography></a></div>
      <div onClick={() => setIsAboutOpen(false)}><a style={linkStyles} href="https://pt.chanpureland.org/"><Typography variant="h3" fontSize="1.1rem">Português</Typography></a></div>
      </div>
      }
</div></Nav.Item>
</>;

if((typeof window !== 'undefined') && window.screen.width<668) {
    const activitiesMenu=  <>  <MenuItem onClick={handleClose}><Link to="/upcoming-events" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">活動預告</Typography></Link></MenuItem>
      <MenuItem onClick={handleClose}><Link to="/activities" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">道場活動安排</Typography></Link></MenuItem>
      <MenuItem onClick={handleClose}><Link to="/livestream" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">直播</Typography></Link></MenuItem>
      <MenuItem onClick={handleClose}><Link to="/onlineClass" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">線上共修</Typography></Link></MenuItem>
      <MenuItem onClick={handleClose}><Link to="/foqi" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">佛七</Typography></Link></MenuItem>
      <MenuItem onClick={handleClose}><Link to="/chanqi" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">禪七</Typography></Link></MenuItem>
      <MenuItem onClick={handleClose}><Link to="/relics" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">舍利展</Typography></Link></MenuItem>
      </>;

const languagesMenu=  <>  <MenuItem onClick={handleClose}><a href="https://www.chanpureland.org/" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">English</Typography></a></MenuItem>
<MenuItem onClick={handleClose}><a href="https://vn.chanpureland.org/" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">Tiếng Việt</Typography></a></MenuItem>
<MenuItem onClick={handleClose}><a href="https://kr.chanpureland.org/" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">한국어</Typography></a></MenuItem>
<MenuItem onClick={handleClose}><a href="https://es.chanpureland.org/" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">Español</Typography></a></MenuItem>
<MenuItem onClick={handleClose}><a href="https://pt.chanpureland.org/" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">Português</Typography></a></MenuItem>
</>;

const sutraLecturesMenu=<><MenuItem onClick={handleClose}><Link to="/avatamsaka-sutra" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">華嚴經</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><Link to="/sixth-patriarch-sutra" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">六祖壇經</Typography></Link></MenuItem>
</>

const audioAndSlidesMenu=<>
<MenuItem onClick={()=>handleExpandItem("sutraLectures")}><Typography variant="h3" fontSize="1.1rem" style={linkStyles}>講經</Typography><Typography variant="h3" fontSize="1.1rem" style={{textAlign: "right", marginLeft: "1.5rem", color: "white"}}>⤋</Typography></MenuItem>
{expandItem=="sutraLectures" ? sutraLecturesMenu : <></>}
<MenuItem onClick={handleClose}><Link to="/dharmatalk-901788" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">開示全集</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><Link to="/dharmatalk" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">禪修開示全集</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><Link to="/fo-qi-archive" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">佛七全集</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><Link to="/chan-qi-archive" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">禪七全集</Typography></Link></MenuItem>
</>

const dharmaMenu=  <>  <MenuItem onClick={()=>handleExpandItem("audioAndSlides")}><Link  to="/lecture" style={linkStyles}><Typography variant="h3" fontSize="1.1rem" onClick={handleClose}>講法音頻和幻燈片</Typography></Link><Typography variant="h3" fontSize="1.1rem" style={{textAlign: "right", marginLeft: "1.5rem", color:"white"}}>⤋</Typography></MenuItem>
{["audioAndSlides", "sutraLectures"].includes(expandItem) ? audioAndSlidesMenu : <></>}

<MenuItem onClick={handleClose}><Link to="/ceremonies" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">法會錄音</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><Link style={linkStyles} activeStyle={activeStyles}  to="/blog"><Typography variant="h3" fontSize="1.1rem">法音博客</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><Link style={linkStyles} activeStyle={activeStyles}  to="/qanda"><Typography variant="h3" fontSize="1.1rem">答疑</Typography></Link></MenuItem></>;

const aboutMenu=<><MenuItem onClick={handleClose}><Link  to="/statement-of-faith" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">我們的宗旨</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><Link to="/location" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">地址</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><Link to="/master" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">永化法師</Typography></Link></MenuItem>
<MenuItem onClick={handleClose}><a href="mailto:xq2@chanpureland.org" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">聯繫我們</Typography></a></MenuItem>
<MenuItem onClick={handleClose}><Link to="/contribution" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">護持捐款</Typography></Link></MenuItem></>

const practiceMenu=<><MenuItem onClick={handleClose}><Link to="/practices" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">修行</Typography></Link></MenuItem>
  <MenuItem onClick={handleClose}><Link to="/training" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">僧伽及居士訓練</Typography></Link></MenuItem>
  <MenuItem onClick={handleClose}><Link style={linkStyles} activeStyle={activeStyles} to="/cultivation-stories"><Typography variant="h3" fontSize="1.1rem">禪修體驗</Typography></Link></MenuItem></>


    navItems=<Nav.Item>
      <IconButton
style={{ background: "#282c34", color: "white" }}
        onClick={handleClick}
      >
        <DensityMediumIcon sx={{fontSize:35}} />
      </IconButton>
    <Menu
    anchorEl={anchorEl}
    anchorOrigin={{horizontal: 'left', vertical: 'bottom' }}
    open={open}
    onClose={handleClose}
    MenuListProps={{
      'aria-labelledby': 'basic-button',
    }}
    PaperProps={{
        sx: {
          backgroundColor: "#282c34", // Change to your desired color
        },
      }}
  >
  <MenuItem onClick={handleClose} ><Link to="/" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">主頁</Typography></Link></MenuItem>
    <MenuItem onClick={()=>handleExpandItem("activities")}><Typography variant="h3" fontSize="1.1rem" style={linkStyles}>活動</Typography><Typography variant="h3" fontSize="1.1rem" style={{textAlign: "right", marginLeft: "1.5rem", color: "white"}}>⤋</Typography></MenuItem>
    {expandItem=="activities" ? activitiesMenu : <></>}
    <MenuItem onClick={handleClose}><Link to="/calendar" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">日曆</Typography></Link></MenuItem>
    <MenuItem onClick={()=>handleExpandItem("Dharma")}><Typography variant="h3" fontSize="1.1rem" style={linkStyles}>佛法</Typography><Typography variant="h3" fontSize="1.1rem" style={{textAlign: "right", marginLeft: "1.5rem", color: "white"}}>⤋</Typography></MenuItem>
    {["Dharma", "audioAndSlides", "sutraLectures"].includes(expandItem) ? dharmaMenu : <></>}


    <MenuItem onClick={()=>handleExpandItem("practices")}><Typography variant="h3" fontSize="1.1rem" style={linkStyles}>修行</Typography><Typography variant="h3" fontSize="1.1rem" style={{textAlign: "right", marginLeft: "1.5rem", color: "white"}}>⤋</Typography></MenuItem>
    {expandItem=="practices" ? practiceMenu : <></>}
    <MenuItem onClick={()=>handleExpandItem("about")}><Typography variant="h3" fontSize="1.1rem" style={linkStyles}>簡介</Typography><Typography variant="h3" fontSize="1.1rem" style={{textAlign: "right", marginLeft: "1.5rem", color: "white"}}>⤋</Typography></MenuItem>
    {expandItem=="about" ? aboutMenu : <></>}
    <MenuItem onClick={handleClose}>
    <Link to="/publication" style={linkStyles}><Typography variant="h3" fontSize="1.1rem">書籍</Typography></Link></MenuItem>
    <MenuItem onClick={()=>handleExpandItem("languages")}><Typography variant="h3" fontSize="1.1rem" style={linkStyles}>語言</Typography><Typography variant="h3" fontSize="1.1rem" style={{textAlign: "right", marginLeft: "1.5rem", color: "white"}}>⤋</Typography></MenuItem>
    {expandItem=="languages" ? languagesMenu : <></>}
  </Menu>
  </Nav.Item>
  }

  return (<Navbar bg="dark" variant="dark" sticky="top" >
    <ThemeProvider theme={theme}>
      <Container>
        <Navbar.Brand href="/">
          <img
            src="/bli-logo.png"
            loading="eager"
            width={45} /></Navbar.Brand>
        <Nav justify className="justify-content-end">

{navItems}
        </Nav>
      </Container>
    </ThemeProvider>
  </Navbar>);
};


function SocialMediaButtons() {
  let size="large";
if((typeof window !== 'undefined') && window.screen.width<667) {
  size="tiny";
}

return <span><a href='http://facebook.com/MasterYongHua/' target='_blank' alt='Facebook' aria-label='Facebook'><FacebookRoundedIcon fontSize={size} /></a>&#32;&#32;<a href='https://www.instagram.com/bodhilightintl/' target='_blank' alt='Instagram' aria-label='Instagram'><InstagramIcon fontSize={size} /></a>&#32;&#32;<a href='https://www.youtube.com/user/MasterYongHua' target='_blank' alt='Youtube' aria-label='Youtube'><YouTubeIcon fontSize={size} /></a>&#32;&#32;<a href='https://twitter.com/MasterYongHua' target='_blank' alt='Twitter' aria-label='Twitter'><TwitterIcon fontSize={size} /></a>&#32;&#32;<a href='mailto:info@chanpureland.org' target='_blank' alt='Mail' aria-label='Mail'><EmailRoundedIcon fontSize={size} /></a></span>
}


export const Layout = ({ children }) => {

  let footerFontSize="20px";
  if(typeof window !== 'undefined') {
    if (window.screen.width<375) {
      footerFontSize="13px";
    } else if (window.screen.width<667) {
      footerFontSize="15px";
    }
  }

  return (
    <>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
<link href="https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@200;400&family=PT+Serif&display=swap" rel="stylesheet" />
<link href="https://github.com/incredibleray/fonts/raw/main/kaiti-700.css" rel="stylesheet" />



      <ThemeProvider theme={theme}>
        <div style={{
          margin: `0 auto`,
          maxWidth: `var(--size-content)`,
          padding: `var(--size-gutter)`,
        }}>

          <main>{children}</main>
        </div>
        <div style={{ backgroundColor: "black" }}>
          <Table style={{ tableLayout: "fixed" }}>
            <tbody>
              <tr></tr>
              <tr><td colSpan={1} rowSpan={3}></td>
                <td colSpan={2}>
                  <Typography variant='h6' fontSize={footerFontSize} color="#2a92e5">RELATED LINKS</Typography>
                </td>
                <td colSpan={2} ><SocialMediaButtons /></td><td rowSpan={3}></td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <Typography variant='body1'>
                    <Link to="/location">Temple Locations</Link><br />
                    <a href="http://www.MahaStupa.org/" target="_blank">MahaStupa.org</a><br />

                  </Typography>
                </td>
                <td colSpan={2}>
                  <Typography variant='h6' fontSize={footerFontSize} color="#2a92e5"><a href="http://eepurl.com/H9_o9" target="_blank">Subscribe</a></Typography>

                  <Typography variant="body1" color="#d5d5d5">Join our mailing list today!<br /><br />
                    <a href="http://eepurl.com/H9_o9" target="_blank">
                      <Button style={{ background: "#282c34", color: "white" }}> Join Now</Button>
                    </a></Typography> </td>
              </tr>
              <tr>
                <td colSpan={2} />
                <td colSpan={2} />
              </tr>
            </tbody>
          </Table>
        </div>
      </ThemeProvider>
    </>
  )
}
